import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import BookingsList from '../components/admin/modules/bookings/BookingsList';
import CalendarView from '../components/admin/modules/calendar/CalendarView';
import PaymentsReport from '../components/admin/modules/payments/PaymentsReport';

type AdminTab = 'bookings' | 'calendar' | 'payments';

const AdminPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AdminTab>('bookings');

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
          <div className="flex space-x-2">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              onClick={() => window.print()}
            >
              Export Data
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8">
            <button
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'bookings'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('bookings')}
            >
              Bookings
            </button>
            <button
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'calendar'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('calendar')}
            >
              Calendar
            </button>
            <button
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'payments'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('payments')}
            >
              Payments
            </button>
          </nav>
        </div>

        {/* Tab content */}
        <div className="bg-white shadow-md rounded-lg p-6">
          {activeTab === 'bookings' && <BookingsList />}
          {activeTab === 'calendar' && <CalendarView />}
          {activeTab === 'payments' && <PaymentsReport />}
        </div>
      </div>
    </Layout>
  );
};

export default AdminPage;
